import { render } from "./DashboardTabs.vue?vue&type=template&id=5f1c2991&scoped=true"
import script from "./DashboardTabs.vue?vue&type=script&lang=js"
export * from "./DashboardTabs.vue?vue&type=script&lang=js"

import "./DashboardTabs.vue?vue&type=style&index=0&id=5f1c2991&scoped=true&lang=scss"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1c2991"]])

export default __exports__